// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { ACTIVITY_TYPES_VIEW_MODE, } from "."
import { ViewMode } from "../slice"

export type StorageWriter = (value: ViewMode) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(ACTIVITY_TYPES_VIEW_MODE, value.toString())
}

export const persistViewMode = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setViewMode.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.viewModePersisted()),
        catchError(_ => of(Actions.viewModePersistFailed())),
      )),
    )

export default persistViewMode(persist)

